import { FunctionComponent } from 'react'

import { IconProps } from '@fairhq/common/lib/components/atoms/icons/types'

export const BarsChart: FunctionComponent<IconProps> = ({
  fill = 'currentColor',
  width = '24',
  height = '24',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9388 8.85203H9.68169C9.52029 8.85203 9.38945 8.98287 9.38945 9.14427V21.6452C9.38945 21.8066 9.52029 21.9374 9.68169 21.9374H13.9388C14.1002 21.9374 14.231 21.8066 14.231 21.6452V9.14427C14.231 8.98287 14.1002 8.85203 13.9388 8.85203Z"
      fill={fill}
    />
    <path
      d="M20.2459 4.49023H15.9888C15.8274 4.49023 15.6966 4.62107 15.6966 4.78247V21.6452C15.6966 21.8066 15.8274 21.9374 15.9888 21.9374H20.2459C20.4073 21.9374 20.5382 21.8066 20.5382 21.6452V4.78247C20.5382 4.62107 20.4073 4.49023 20.2459 4.49023Z"
      fill={fill}
    />
    <path
      d="M7.64018 13.2138H3.38306C3.22166 13.2138 3.09082 13.3447 3.09082 13.5061V21.6452C3.09082 21.8066 3.22166 21.9374 3.38306 21.9374H7.64018C7.80158 21.9374 7.93242 21.8066 7.93242 21.6452V13.5061C7.93242 13.3447 7.80158 13.2138 7.64018 13.2138Z"
      fill={fill}
    />
  </svg>
)
